import { render, staticRenderFns } from "./ORUsersTable.vue?vue&type=template&id=278f233a&scoped=true"
import script from "./ORUsersTable.vue?vue&type=script&lang=js"
export * from "./ORUsersTable.vue?vue&type=script&lang=js"
import style0 from "./ORUsersTable.vue?vue&type=style&index=0&id=278f233a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278f233a",
  null
  
)

export default component.exports